var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIconRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.081,
    height: 17.002,
    viewBox: "0 0 14.081 17.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone",
    "data-name": "Icon feather-phone",
    d: "M16.248,14.979v2.409a1.786,1.786,0,0,1-.426,1.19,1.176,1.176,0,0,1-1.008.416,11.6,11.6,0,0,1-5.676-2.465,14.583,14.583,0,0,1-3.946-4.817A18.268,18.268,0,0,1,3.173,4.75a1.84,1.84,0,0,1,.339-1.227A1.222,1.222,0,0,1,4.482,3H6.455A1.43,1.43,0,0,1,7.77,4.381a12.212,12.212,0,0,0,.46,2.256,1.871,1.871,0,0,1-.3,1.694L7.1,9.351a11.96,11.96,0,0,0,3.946,4.817l.835-1.02a1.149,1.149,0,0,1,1.388-.361,7.226,7.226,0,0,0,1.848.562A1.545,1.545,0,0,1,16.248,14.979Z",
    transform: "translate(-2.667 -2.5)",
    fill: "none",
    stroke: "#B3001B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconRed);
export default __webpack_public_path__ + "static/media/phoneIconRed.753c48dceebafb66c7a41d297dd3c10e.svg";
export { ForwardRef as ReactComponent };